<script setup lang="ts" generic="T extends string">
import { reactive } from "vue";
import BooleanBox from "./BooleanBox.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { BooleanBox }
});

const props = withDefaults(
  defineProps<{
    options: Array<T>;
    disabledIndexs?: Array<number>;
    initIndexs?: Array<number>;

    isRounded?: boolean;

    colorBackground?: string;
    colorForeground?: string;
    colorDisabled?: string;

    colorChangeMode?: "reverse" | "only-foreground";

    fontSize?: string;
    boxWidth?: string;
    itemPadding?: string;
    labelPadding?: string;
  }>(),
  {
    isRounded: false,

    colorBackground: "#ffffff",
    colorForeground: "#5a82f0",
    colorDisabled: "#cccccc",

    colorChangeMode: "reverse",

    fontSize: "14px",
    boxWidth: "20px",
    itemPadding: "10px",
    labelPadding: "2px"
  }
);

const emits = defineEmits<{
  (event: "change", values: T[]): void;
}>();

let selectedIndexes = reactive(props.initIndexs ?? []);

const change = (index: number, selected: boolean) => {
  const findIndex = selectedIndexes.findIndex((i) => i === index);
  let isChange = false;
  if (findIndex >= 0 && !selected) {
    selectedIndexes.splice(findIndex, 1);
    isChange = true;
  } else if (findIndex < 0 && selected) {
    selectedIndexes.push(index);
    isChange = true;
  }
  if (isChange) {
    emits(
      "change",
      selectedIndexes.map((index) => props.options[index])
    );
  }
};
</script>

<template>
  <div
    class="checkbox-group"
    v-for="(option, index) in options"
    :key="index"
    :style="['margin-left:' + (index > 0 ? props.itemPadding : 0)]"
  >
    <BooleanBox
      :selected="selectedIndexes.findIndex((i) => i === index) >= 0"
      :disabled="
        disabledIndexs && disabledIndexs.findIndex((i) => i === index) >= 0
      "
      :isRounded="props.isRounded"
      :label="option"
      :labelPadding="props.labelPadding"
      :colorBackground="props.colorBackground"
      :colorForeground="props.colorForeground"
      :colorDisabled="props.colorDisabled"
      :colorChangeMode="props.colorChangeMode"
      :boxWidth="props.boxWidth"
      :fontSize="props.fontSize"
      @change="(v) => change(index, v)"
    ></BooleanBox>
  </div>
</template>

<style scoped>
.checkbox-group {
  position: relative;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
